module.exports = __webpack_public_path__ + "img/check.1f3001d9.svg";